import {
  MODAL_ADD_BIENEST,
  MODAL_DET_BIENEST,
  MODAL_GES_BIENEST,
  MODAL_OBS_BIENEST,
  MODAL_ADD_FILTRO_BIENEST,
  MODAL_FORMATOS_BIENEST,
  MODAL_MATERIAL_APOYO_BIENEST,
  MODAL_CONFIRMAR_REMI_BIENEST,
  MODAL_DET_BIENEST_FORMATOS,
  MODAL_ASIGNAR_PROFESIONAL_BIENEST,
} from "../actions/actBienestar";


const initialState = {
  modalGestionarBienestar: false,
  modalObservacionBienestar: false,
  modalAddFiltrosBienestar: false,
  modalAddBienestar: false,
  modalDetalleBienestar: false,
  modalFormatosBienestar: false,
  modalMaterialApoyoBienestar: false,
  modalConfirmarRemisionBienestar: false,
  modalDetalleBienestarFormatos: false,
  modalAsignarProfesionalBienestar: false,
  mostrarCampos: true
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_ADD_BIENEST:
      return Object.assign({}, state, {
        modalAddBienestar: action.show
      })
    case MODAL_DET_BIENEST:
      return Object.assign({}, state, {
        modalDetalleBienestar: action.show
      })

    case MODAL_GES_BIENEST:
      return Object.assign({}, state, {
        modalGestionarBienestar: action.show
      })

    case MODAL_OBS_BIENEST:
      return Object.assign({}, state, {
        modalObservacionBienestar: action.show
      })

    case MODAL_ADD_FILTRO_BIENEST:
      return Object.assign({}, state, {
        modalAddFiltrosBienestar: action.show,
        mostrarCampos: action.mostrarCampos,
      })

    case MODAL_FORMATOS_BIENEST:
      return Object.assign({}, state, {
        modalFormatosBienestar: action.show
      })

    case MODAL_MATERIAL_APOYO_BIENEST:
      return Object.assign({}, state, {
        modalMaterialApoyoBienestar: action.show
      })

    case MODAL_CONFIRMAR_REMI_BIENEST:
      return Object.assign({}, state, {
        modalConfirmarRemisionBienestar: action.show
      })

    case MODAL_DET_BIENEST_FORMATOS:
      return Object.assign({}, state, {
        modalDetalleBienestarFormatos: action.show
      })

    case MODAL_ASIGNAR_PROFESIONAL_BIENEST:
      return Object.assign({}, state, {
        modalAsignarProfesionalBienestar: action.show
      })
      
    default:
      return state;
  }
}

export default reducer;
